import PolicyLayout from './PolicyLayout';
import { SITE_NAME, SITE_DOMAIN } from '../constants/site';
import { CONTACT } from '../constants/contact';

export default function PrivacyPolicy() {
  return (
    <PolicyLayout title="Privacy Policy">
      <h2>Who we are</h2>
      <p>
        {CONTACT.company} operates {SITE_NAME} at {SITE_DOMAIN}. This policy explains how we collect and
        use information when you request Dragon support or contact our team.
      </p>
      <h2>Information we collect</h2>
      <p>
        We may collect your name, email, phone number, Dragon product version, device details you share,
        and messages you send so we can provide technical assistance.
      </p>
      <h2>How we use information</h2>
      <p>
        We use your information to respond to support requests, improve our services, and communicate
        about orders or callbacks. We do not sell personal information.
      </p>
      <h2>Contact</h2>
      <p>
        Privacy requests: {CONTACT.email}. Mailing address: {CONTACT.address}.
      </p>
    </PolicyLayout>
  );
}
